<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">佣金明细</div>
          <div class="money">
            ￥<span class="num">{{ commission }}</span>
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="sign-record">
      <div class="list">
        <div class="item">
          <div class="listn">
            <div
              class="itemn acea-row row-between-wrapper"
              v-for="(val, indexn) in list"
              :key="indexn"
            >
              <div>
                <div class="name line1">获得推广佣金</div>
                <div>{{ fromatDate(val.created) }}</div>
              </div>
              <div class="num">+{{ val.money }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getCommissionInfo, commissionTotal } from "@api/activity";
import Loading from "@components/Loading";
import dayjs from "dayjs";
export default {
  name: "CommissionDetails",
  components: {
    Loading,
  },
  props: {},
  data: function () {
    return {
      list: [],
      id: this.$route.params.id,
      commission: 0,
      where: {
        pageNO: 1,
        param: {},
        pageSize: 20,
      },
      types: 1,
      loaded: false,
      loading: false,
    };
  },
  mounted: function () {
    this.getIndex();
    this.getCommissionTotal();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    fromatDate(time) {
      return dayjs.unix(time).format("YYYY-MM-DD HH:mm");
    },
    getCommissionTotal() {
      commissionTotal(this.id).then((res) => {
        this.commission = res.result || 0;
      });
    },
    getIndex: function () {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      let { pageNO, pageSize } = that.where;
      getCommissionInfo(this.id, { pageNO, pageSize }).then(
        (res) => {
          that.loading = false;
          that.list = that.list.concat(res.result.records || []);

          that.loaded = that.list.length == res.result.total;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.pageNO = that.where.pageNO + 1;
          that.where.param = res.result.param;
          that.count = res.result.total;
        },
        (error) => {
          that.$dialog.message(error.msg);
        }
      );
    },
  },
};
</script>
